export default __webpack_public_path__ + "static/media/CNo.78-0.7c184ef8.jpg";